import { useState } from "react";
import { Link } from "react-router";
import { Menu, type LucideIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { cn } from "@/lib/utils";

interface FloatingButtonNavigationProps {
  navLinks: Array<{
    path: string;
    icon: LucideIcon;
    label: string;
  }>;
  isActive: (path: string) => boolean;
  translator: (key: string, opts?: Record<string, string>) => string;
}

const FloatingButtonNavigation = ({
  navLinks,
  isActive,
  translator,
}: FloatingButtonNavigationProps) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
      <SheetTrigger asChild>
        <Button
          variant="secondary"
          size="icon"
          className="fixed bottom-4 right-4 z-50 h-16 w-16 rounded-full shadow-lg [&_svg]:size-6"
          aria-label={translator("Navigation.openMenu")}        >
          <Menu />
        </Button>
      </SheetTrigger>
      <SheetContent
        side="bottom"
        className="h-auto pb-10"
        aria-describedby={undefined}
      >
        <SheetTitle className="sr-only">
          {translator("Navigation.menu")}
        </SheetTitle>
        <nav className="flex flex-col gap-2 pt-6">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setMobileMenuOpen(false)}
              className={cn(
                "flex items-center gap-3 px-4 py-3 my-1 rounded-md",
                isActive(link.path)
                  ? "bg-primary text-primary-foreground"
                  : "hover:bg-muted",
              )}
            >
              <link.icon className="h-5 w-5" />
              {translator(link.label)}
            </Link>
          ))}
        </nav>
      </SheetContent>
    </Sheet>
  );
};

export default FloatingButtonNavigation;
